// in a separate PR disable this and serve pages from server only
import angular from "angular";
const tpl = require("./viewApt.html");

function isVow() {
  return angular.element("#display-vow-listing").length;
}

ViewAptCtrl.config = function ($routeProvider) {
  $routeProvider.when("/:aptId/slug", {
    controller: "ViewAptCtrl",
    templateUrl: tpl,
    resolve: {
      apt: [
        "PageStore",
        "AptService",
        "$route",
        function (PageStore, AptService, $route) {
          // REBNY vow listings are not rendered by server, only via the frontend
          if (PageStore.isInitialPage() && !isVow()) {
            // apt is server-side rendered on the page
            return;
          }
          return AptService.get($route.current.params.aptId);
        },
      ],
    },
  });

  // set the regexp
  // because ng-route doesnt offer route matching
  const $route = $routeProvider.$get[$routeProvider.$get.length - 1]({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $on: function () {},
  });
  $route.routes["/:aptId/slug"].regexp = /^\/(\d+)\/([^/]*)$/i;
  $route.routes["/:aptId/slug/"].regexp = /^\/(\d+)\/([^/]*)\/$/i;
  // $route.routes['/:aptId/slug'].regexp = /^\/(\d+)\/(?!print)$/i;
  // $route.routes['/:aptId/slug/'].regexp = /^\/(\d+)\/(?!print)\/$/i;
};
ViewAptCtrl.config.$inject = ["$routeProvider"];

ViewAptCtrl.$inject = ["$scope", "apt", "inits", "flux"];
export function ViewAptCtrl($scope, apt, inits, flux) {
  if (apt) {
    // a REBNY vow listing served on an initial page load
    $scope.apt = apt;

    inits.controllerWillRender({
      removeServerSideContent: true,
      objectTools: apt.object_tools,
      bodyId: "view-apt",
      pageStore: {
        // breadcrumbs: apt.breadcrumbs,
        insideTop: "",
        pageTitle: apt.page_title || "#" + apt.id,
        // innerTitle: apt.title
      },
    });
  } // else its in server rendered content
  // and viewApt.html does not show anything at all
}
